import script from "./SkillsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SkillsSection.vue?vue&type=script&setup=true&lang=js"

import "./SkillsSection.vue?vue&type=style&index=0&id=5f5d6772&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f5d6772"]])

export default __exports__